module.exports = __webpack_public_path__ + "media/flags/pn-35a3a02f.svg";